<template>
  <wui-avatar
    :contact="contact"
    :name="name!"
    :background="background!"
    color="white"
    :size="64"
    class="avatar-circle"
    :class="{ 'avatar-circle-loading': loading }"
  />
</template>

<script lang="ts" setup>
import { WuiAvatar } from '@wui/common-library'
import { computed } from 'vue'

import { useCurrentUser } from '@/shared/composables/current-user'
import { useUserColor } from '@/shared/composables/user-color'

import { useStoreContacts } from '../store'

const props = withDefaults(defineProps<{
  pServed: string,
  loading?: boolean,
}>(), {
  loading: false,
})

const { getColorByName } = useUserColor()
const { findByPServed } = useStoreContacts()
const { currentUser } = useCurrentUser()

const name = computed(() => {
  if (contact.value?.lastName) {
    return `${contact.value.lastName} ${contact.value.firstName}`
  }

  return contact.value?.name
})

const contact = computed(() => {
  if (currentUser.value?.imLogin === props.pServed) {
    return currentUser.value
  }
  return findByPServed(props.pServed)
})

const background = computed(() => {
  if (!name.value) {
    return 'primary'
  }
  return getColorByName(name.value, false)
})
</script>
<style>
.avatar-circle {
  transition: all 1s linear;
}

.avatar-circle-loading {
  animation: 1s linear .1s infinite alternate participantLoading;
}
</style>
